import Head from "next/head";
import Navbar from "../components/general/Navbar";
import Header from "../components/general/Header";
import Footer from "../components/general/Footer";
import RememberPasswordForm from "../components/form/RememberPasswordForm";

export default function Home({navigation }) {

    return (
        <div className="min-h-screen flex flex-col">
            <Head>
                <title>Olaf Nijenkamp | Home</title>
                <meta name="description" content="Generated by create next app" />
            </Head>

            <header>
                <Navbar items={navigation} />
                <Header small={true} customStyles="pb-8 lg:pb-20" />
            </header>

            <main className="olafGrid z-10">
                <section className="mt-16">
                    <div className="olafGrid space-y-4 lg:max-w-lg">
                        <RememberPasswordForm />
                    </div>
                </section>
            </main>

            <Footer />
        </div>
    );
}
